import { render, staticRenderFns } from "./MarronsGame.vue?vue&type=template&id=6aedff7b&"
import script from "./MarronsGame.vue?vue&type=script&lang=js&"
export * from "./MarronsGame.vue?vue&type=script&lang=js&"
import style0 from "./MarronsGame.vue?vue&type=style&index=0&id=6aedff7b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports